import { render, staticRenderFns } from "./wechat-index.vue?vue&type=template&id=a114da84&scoped=true&"
import script from "./wechat-index.vue?vue&type=script&lang=js&"
export * from "./wechat-index.vue?vue&type=script&lang=js&"
import style0 from "./wechat-index.vue?vue&type=style&index=0&id=a114da84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a114da84",
  null
  
)

export default component.exports